import React from 'react';
import { CheckCircle, Clock, AlertCircle } from 'lucide-react';
interface SyncStatusBadgeProps {
  status: 'synced' | 'pending' | 'error';
}
export function SyncStatusBadge({
  status
}: SyncStatusBadgeProps) {
  const config = {
    synced: {
      icon: CheckCircle,
      text: 'Synced',
      color: 'text-green-400 bg-green-400/10 border-green-400/20'
    },
    pending: {
      icon: Clock,
      text: 'Pending',
      color: 'text-yellow-400 bg-yellow-400/10 border-yellow-400/20'
    },
    error: {
      icon: AlertCircle,
      text: 'Error',
      color: 'text-red-400 bg-red-400/10 border-red-400/20'
    }
  };
  const {
    icon: Icon,
    text,
    color
  } = config[status];
  return <span className={`inline-flex items-center space-x-1 px-2 py-0.5 rounded-full text-xs font-medium border ${color}`} data-id="element-100">
      <Icon size={10} data-id="element-101" />
      <span data-id="element-102">{text}</span>
    </span>;
}